<template>
  <draggable
    animation="200"
    ghostClass="ghost"
    tag="ul"
    class="steps-list"
    :list="steps"
    @change="$emit('change', $event)"
  >
    <li class="steps-list__item" :key="step.id" v-for="step in steps">
      <StepItem
        :id="step.id"
        :parent_id="step.parent_id"
        :step_code="step.step_code"
        :title="step.title"
        @add="$emit('add', $event)"
        @edit="$emit('edit', $event)"
        @delete="$emit('delete', $event)"
      />

      <scenario-steps-list
        :steps="step.children"
        @add="$emit('add', $event)"
        @edit="$emit('edit', $event)"
        @delete="$emit('delete', $event)"
        @change="$emit('change', $event)"
      />
    </li>
  </draggable>
</template>

<script>
import draggable from 'vuedraggable'
import StepItem from './StepItem'

export default {
  name: 'scenario-steps-list',
  props: {
    steps: {
      required: true,
      type: Array
    }
  },
  components: {
    draggable,
    StepItem
  }
}
</script>

<style lang="scss">
  .steps-list {
    &__item {
      cursor: move;
      & > .steps-list {
        padding-left: 10%;
      }
    }
  }

  .flip-list-move {
    transition: transform 0.5s;
  }

  .no-move {
    transition: transform 0s;
  }

  .ghost {
    opacity: 0.4;
    box-shadow: 0 0 0 2px #f5a61f;
    border-radius: 8px;
  }
</style>
